export const IMGIX_URL = 'https://darkovakrabicka.imgix.net/';
const CLOUDINARY_URL = 'https://res.cloudinary.com/dkxyexwn6/image/fetch/';
const S3_URL = 'https://darkovakrabicka.s3.amazonaws.com/upload/';

export default function(imageId, format, width, height, dpr,isGreyscale, bg) {
    const service = 'imgix'; //set cloudinary || imgix //pokud se nekdy bude menit service, je potreba prepsat photo uploader a zobrazeni fotky v packagedetail manualne - pouziva jiny bucket a source

    //set image density automaticaly or use the preset value
    let density = window.devicePixelRatio > 1 ? 2 : 1;

    if (dpr) {
        density = dpr;
    }

    if (service === 'cloudinary') {
        let params = `dpr_${density}`;

        if (width) {
            params += `,w_${width}`;
        }

        if (density > 1) {
            params += ',q_45';
        }

        if (height) {
            params += `,h_${height}`;
        }

        if (width && height) {
            params += `,c_fill`;
        }

        if (isGreyscale) {
            params += `,e_grayscale`;
        }

        return `${CLOUDINARY_URL}${params}/${S3_URL}${imageId}.${format}`;
    }

    if (service === 'imgix') {
        let params = `dpr=${density}&auto=format,compress`;

        if (width) {
            params += `&w=${width}`;
        }

        if (density > 1) {
            params += '&q=40';
        }

        if (height) {
            params += `&h=${height}`;
        }

        if (width  && height  && bg)  {
            params +=`&fit=fill&bg=${bg}` ;
        } else if  (width && height){
          params +=  `&fit=crop`;
        }

        if (isGreyscale) {
            params += `&sat=-90`;
        }

        return `${IMGIX_URL}${imageId}.${format}?${params}`;
    }
}
